'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactApplication(id, code, groups, plans) {
  this.KK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.KJ = null;
  this.xa = null;
  this.tP = null;
  this.KK = id;
  this.KJ = code;
  this.xa = groups;
  this.tP = plans;
}
export { $c_Lpresto_types$CompactApplication as $c_Lpresto_types$CompactApplication };
$p = $c_Lpresto_types$CompactApplication.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactApplication;
/** @constructor */
function $h_Lpresto_types$CompactApplication() {
}
export { $h_Lpresto_types$CompactApplication as $h_Lpresto_types$CompactApplication };
$h_Lpresto_types$CompactApplication.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("CompactApplication"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.KK;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.KJ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xa));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tP));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 4);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$CompactApplication)) {
    var this$1 = this.KK;
    var b = x$0.KK;
    if ((((this$1.e === b.e) && (this$1.f === b.f)) && (this.KJ === x$0.KJ))) {
      var x = this.xa;
      var x$2 = x$0.xa;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.tP;
      var x$4 = x$0.tP;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "CompactApplication";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.KK;
      break;
    }
    case 1: {
      return this.KJ;
      break;
    }
    case 2: {
      return this.xa;
      break;
    }
    case 3: {
      return this.tP;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$CompactApplication(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jr)));
}
export { $isArrayOf_Lpresto_types$CompactApplication as $isArrayOf_Lpresto_types$CompactApplication };
var $d_Lpresto_types$CompactApplication = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactApplication, "presto.types$CompactApplication", ({
  jr: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CompactApplication as $d_Lpresto_types$CompactApplication };
//# sourceMappingURL=presto.types$-Compact-Application.js.map
